<template>
    <div class="ei-roll-hor">
        <div class="page">
            page1
        </div>
        <div class="page">
            page2
        </div>
        <div class="page">
            page3
        </div>
    </div>
</template>

<script>
export default {
    name: 'EiRollHor',
    mounted() {
        let container = document.querySelector('.ei-roll-hor')
        container.addEventListener('wheel', (event) => {
            event.preventDefault();
            container.scrollLeft += event.deltaY
        })
    },
    methods: {

    },

}
</script>

<style scope>
* {
    box-sizing: border-box;
    padding: 0;
    margin: 0;
}
.ei-roll-hor {
    display: flex;
    overflow-x: scroll;
    overflow-y: hidden;
}
.page {
    width: 100vw;
    height: 100vh;
    flex-shrink: 0;
}
.page:nth-child(1) {
    background-color: #5db267;
}
.page:nth-child(2) {
    background-color: #3e77b9;
}
.page:nth-child(3) {
    background-color: #7336be;
}
</style>